
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.5 19.06a2 2 0 100 4 2 2 0 000-4zM28.793 25.523a1 1 0 011.707.707v13.71a1 1 0 01-2 0V26.23a1 1 0 01.293-.707z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M29.5 7A22.52 22.52 0 007 29.5 22.52 22.52 0 0029.5 52 22.52 22.52 0 0052 29.5 22.52 22.52 0 0029.5 7zm0 43A20.52 20.52 0 019 29.5 20.53 20.53 0 0129.5 9 20.53 20.53 0 0150 29.5 20.52 20.52 0 0129.5 50z"}})])
          )
        }
      }
    